/*
  Open Pictometry, Google, KML, Bing, etc. with map at the map center & zoom
*/

/* eslint quotes: 0*/

import formatKML from '../node_modules/ol/format/KML.js';
import formatGeoJSON from '../node_modules/ol/format/GeoJSON.js';

import {map} from './index.js';

export default function(mapType) {
  // below gets the zoom for resolution https://stackoverflow.com/questions/29900520/is-there-a-getzoomforresolution-in-openlayers-3/43030167
  // there's now also https://openlayers.org/en/latest/apidoc/module-ol_View-View.html#getZoomForResolution
  const zoom = Math.ceil((Math.log(map.getView().getResolution()) - Math.log(156543.03390625)) / Math.log(0.5)) + 1; // adding 1 is completely subjective
  const center = rwg.proj.transform(rwg.proj.mapSRID, 'EPSG:4326', map.getView().getCenter())
  const p = {x: center[0], y: center[1]}  // making it an object is just for backward compatibility below
  let url

  switch (mapType) {
    case 'Pictometry':
      pictoTab(p, zoom);
      break;
    case 'Pictometry Explorer':
      // 2018-12-06 email from Dustin Walters
      url = 'https://explorer.pictometry.com/?angle=ob&orientation=n&lat=' + p.y + '&lon=' + p.x + '&zoom=' + zoom;
      window.open(url, 'Pictometry').focus();
      break;
    case 'Bing':
      url = 'https://www.bing.com/maps?cp=' +
        p.y + '~' + p.x + '&lvl=' + zoom + '&style=h';
      window.open(url, 'Bing Maps').focus();
      break;
    case 'Google':
      // https://developers.google.com/maps/documentation/urls/guide#map-action
      url = 'https://www.google.com/maps/@?api=1&map_action=map&basemap=satellite&center=' +
        p.y + ',' + p.x + '&zoom=' + zoom;
      window.open(url,'Google Maps').focus();
      break;
    case 'Google with Selection':  // GeoJSON
      url = '/google-map.html'
      let latLongFeatures = selection2LatLong()
      let geoJsonStr = new formatGeoJSON().writeFeatures(latLongFeatures);
      sessionStorage.setItem("selection", geoJsonStr);
      rwg.config.otherMaps?.activeWindow?.close()
      rwg.config.otherMaps.activeWindow = window.open(url,'Google Map') //.focus()
      rwg.config.otherMaps.activeWindow.focus()
      break;
    case 'Google Earth':  // KML
      if (typeof rwg.config.hiliteMethod !== 'undefined' && rwg.config.hiliteMethod === 'vector') {
        let latLongFeatures = selection2LatLong()
        let kml = new formatKML().writeFeatures(latLongFeatures);
        download('selection.kml', kml)
      }
      break;
    default:
  }
}

// return an array of features in the selection cloned and transformed into lat/lng
function selection2LatLong() {
  const features = map.getLayerByTitle('lyrVector').getSource().getFeatures()
  let clonedFeatures = []
  features.forEach(feature => {
    let clonedFeature = feature.clone()
    clonedFeature.getGeometry().transform(rwg.proj.mapSRID, 'EPSG:4326')
    if (!clonedFeature.getStyle()) { // if the feature doesn't have its own style copy layer's style onto it
      let layerStyle = map.getLayerByTitle('lyrVector').getStyleFunction()(feature, map.getView().getResolution());
      clonedFeature.setStyle(layerStyle); // http://stackoverflow.com/questions/43019869/kml-format-writefeatures-defaultstyle
    }
    clonedFeatures.push(clonedFeature)
  })
  return clonedFeatures
}

// http://stackoverflow.com/questions/3665115/create-a-file-in-memory-for-user-to-download-not-through-server
function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

// This is for the pictometry IPA tab, not the Pictometry Explorer
function pictoTab(pt, z) {
  // I have the Pictometry initialization in site_var.php now!
  rwg.tabs.activate('top-othermap')
  rwg.config.otherMaps.Pictometry.ipa.setLocation(pt.y, pt.x, z);
  // enables "Export visible area" in tools menu, needs to be here in code sequence
  rwg.config.otherMaps.Pictometry.ipa.setPreferences({imageDownload: true});
}
